import { supabase } from "@/integrations/supabase/client";
import { trackEvent } from "@/lib/analytics";

export type PaywallEventType = "viewed" | "trial_tap" | "trial_activated";

export async function logPaywallEvent(
  eventType: PaywallEventType,
  opts: { feature?: string; offering?: string; metadata?: Record<string, unknown> } = {}
) {
  try {
    const { data } = await supabase.auth.getUser();
    const userId = data.user?.id;
    if (!userId) return;

    // PostHog mirror
    trackEvent(`paywall_${eventType}`, {
      feature: opts.feature ?? "unknown",
      offering: opts.offering,
      ...opts.metadata,
    });

    await supabase.from("paywall_events").insert([{
      user_id: userId,
      event_type: eventType,
      feature: opts.feature ?? null,
      offering: opts.offering ?? null,
      metadata: (opts.metadata ?? {}) as never,
    }]);
  } catch (err) {
    console.warn("[paywallAnalytics] failed", err);
  }
}
